export const environment = {
  firebase: {
    apiKey: 'AIzaSyBw89GTZ7JaaHZw4SLHMiHggAlcIdd71m8',
    authDomain: 'anima-en-dev-7cbec.firebaseapp.com',
    projectId: 'anima-en-dev-7cbec',
    storageBucket: 'anima-en-dev-7cbec.appspot.com',
    messagingSenderId: '972423687157',
    appId: '1:972423687157:web:9f24519706af45e9420ebc'
  },
  appVersion: require('../../../../package.json').version + '--2dev',
  paypalId: 'AZOlmXhW1-5fC4A1BMatBuJJxcpkNvWF_V68L98v3tQGcwtjMtj9jOxlhtP5DktauEZ6WI2HG2P6QQUl',
  production: true,
  isProd: false,
  cookieDomain: 'anima-en-dev-7cbec.web.app',
  googleClientId: '1082322181123-7rmg57kpndgiutfmetl6alaaljkbv9tu.apps.googleusercontent.com',
  googleTagId: 'GTM-TGQ3FF3',
  facebookClientId: '1',
  defaultLanguage: 'en',
  availableLanguages: ['en', 'es'],
  apiUrl: '/api',
  paypal: 'https://pay-sandbox.anima.help',
  notify: 'https://notify.anima.help',
  aiUrl: 'https://chat-bot-972423687157.us-central1.run.app',
};
